const getDeviceInfo = () => {
  return new Promise((res) => {
    window.HiyaJSBridge.callHandler("getDeviceInfo", null, (info) => {
      res(info);
    });
  });
};
export {
  getDeviceInfo
};
